import axios from 'axios'
// import store from '@/store/'

const env = (process.env.NODE_ENV === 'production')

const config = () => {
  // const port = store.getters.theApis.fdc.sitePort
  // return {
  //   url: env ? ((process.env.VUE_APP_HTTPS_ENABLE === 'true' ? 'https://' : 'http://') + store.getters.theApis.fdc.siteIp) : 'http://localhost',
  //   port: env ? port : '15001'
  // }
  return {
    url: env ? 'https://fdc-api.brique.kr' : 'http://localhost',
    port: env ? '' : ':'.concat('20004')
  }
}

export default {
  saveEventCollectionPlan: async (payload) => {
    try {
      let response = await axios.post(config().url + config().port + '/fdc/dcs/event-plan/save', payload)
      return response
    } catch (error) {
      console.log(error)
    }
  },
  deleteEventCollectionPlan: async (payload) => {
    try {
      let response = await axios.post(config().url + config().port + '/fdc/dcs/event-plan/delete/' + payload.fab + '/' + payload.eqpId + '/' + payload.planName)
      return response
    } catch (error) {
      console.log(error)
    }
  },
  updateTraceCollectionPlan: async (payload) => {
    try {
      let response = await axios.post(config().url + config().port + '/fdc/dcs/trace-plan/save', payload)
      return response
    } catch (error) {
      console.log(error)
    }
  },
  deleteTraceCollectionPlan: async (payload) => {
    try {
      let response = await axios.post(config().url + config().port + '/fdc/dcs/trace-plan/delete', payload)
      return response
    } catch (error) {
      console.log(error)
    }
  },
  getEqpEventList: async (payload) => {
    try {
      let response = await axios.get(config().url + config().port + '/fdc/dcs/event-plan/eqp/event/list/' + payload.fab + '/' + payload.eqpId)
      return response.data === null ? [] : response.data
    } catch (error) {
      console.log(error)
    }
  },
  getEqpParamList: async (payload) => {
    try {
      let response = await axios.get(config().url + config().port + '/fdc/dcs/trace-plan/eqp/param/list/' + payload.fab + '/' + payload.eqpId)
      return response.data === null ? [] : response.data
    } catch (error) {
      console.log(error)
    }
  }
}
